import { render, staticRenderFns } from "./dcPxVideodown.vue?vue&type=template&id=5d4d72c6&scoped=true&"
import script from "./dcPxVideodown.vue?vue&type=script&lang=js&"
export * from "./dcPxVideodown.vue?vue&type=script&lang=js&"
import style0 from "./dcPxVideodown.vue?vue&type=style&index=0&id=5d4d72c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4d72c6",
  null
  
)

export default component.exports